module.exports = __webpack_public_path__ + "files/b4f5232f477d5115a1f9068c5795bc51.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/PT-Sans-regular.woff
// module id = 775
// module chunks = 60